import { Directive } from "@angular/core";

/**
 * Wrapper for list filter controls in a mat-card.
 * Automatically adjusts padding when followed by card-list-actions.
 *
 * @example
 * <mat-card>
 *   <mgd-card-list-filters>
 *     <mat-form-field>
 *       <mat-select placeholder="Filter by...">
 *         <mat-option value="all">All</mat-option>
 *       </mat-select>
 *     </mat-form-field>
 *   </mgd-card-list-filters>
 * </mat-card>
 */
@Directive({
    selector: "mgd-card-list-filters",
    host: {
        class: "mgd-card-list-filters"
    }
})
export class CardListFiltersDirective {}
